<template>
  <transition name="fade" tag="div" class="wrapper">
    <div class="wrapper" v-if="isLoaded" key="app">
      <FrontPage :user="user"/>
      <AboutMe :category="categories['about-me']" :posts="posts['about-me']" :user="user"/>
      <Experience :category="categories.experience" :posts="posts"/>
      <Portfolio :category="categories.portfolio" :posts="posts.portfolio"/>
      <Contacts :category="categories.contact" :posts="posts['about-me']"/>
      <Footer :posts="posts['about-me']"/>
    </div>

    <div class="loader wrapper" v-else key="loader">
     <div class="spinner-loader"></div>
    </div>
  </transition>
</template>

<script>
import { group } from './utils'
import FrontPage from './components/FrontPage'
import AboutMe from './components/AboutMe'
import Experience from './components/Experience'
import Portfolio from './components/Portfolio'
import Contacts from './components/Contacts'
import Footer from './components/Footer'

const API_BASE_URL = 'http://portfolio.freaksidea.com/wp-json'
const API_URL = `${API_BASE_URL}/wp/v2`

// Imágenes del portafolio: public/img/portfolio/ → dist/wp-content/themes/MyTheme/img/portfolio/
const img = (file) => `${process.env.BASE_URL}img/portfolio/${file}`

export default {
  name: 'app',
  components: {
    FrontPage,
    AboutMe,
    Experience,
    Portfolio,
    Contacts,
    Footer,
  },
  data: () => ({
    isLoaded: false,
    categories: {},
    user: {},
    posts: {},
  }),

  methods: {
    getName() {
      console.log("Hi! My name is Richarson Cárcamo. I hope you be okey!")
      console.log("I saw that you are insterested on me. See my Instagram for more information:")
      console.log("@richardscarcamo\nSee you! Take care... Now... I know who you are... I just kidding.")
      return this.user = {
            name: "RICHARDSON CÁRCAMO",
            description: "Computer Science Engineer",
            url: "https://ralc365.web.app",
            home: "https://ralc365.web.app",
            gmt_offset: "3",
            timezone_string: "",
      }
      /*return fetch(API_BASE_URL)
        .then((response) => response.json())
        .then(({ name, description }) => {
          //this.user = { name, description }
          this.user = {
            name: "RICHARDSON CÁRCAMO",
            description: "Computer Science Engineer",
            url: "https://ralc365.web.app",
            home: "https://ralc365.web.app",
            gmt_offset: "3",
            timezone_string: "",
          };
        });*/
    },

    getCategories() {
      //return fetch(`${API_URL}/categories`).then((response) => response.json());

      let categoria = [
        {
          id: 2,
          slug: "about-me",
          name: "About Me",
          description: "LET'S GET TO KNOW ME BETTER",
        },
        {
          id: 12,
          slug: "contact",
          name: "Contact",
          description: "leave your message",
        },
        {
          id: 6,
          slug: "education",
          name: "Education",
          description: "",
        },
        {
          id: 4,
          slug: "experience",
          name: "Experience",
          description: "MY KNOWLEDGE AND ACHIEVEMENT",
        },
        {
          id: 8,
          slug: "portfolio",
          name: "Briefcase",
          description: "SOME OF MY LAST WORKS",
        },
        {
          id: 3,
          slug: "social",
          name: "Social page",
          description: "",
        },
        {
          id: 5,
          slug: "works",
          name: "Works",
          description: "",
        },
        {
          id: 1,
          slug: "%d0%b1%d0%b5%d0%b7-%d1%80%d1%83%d0%b1%d1%80%d0%b8%d0%ba%d0%b8",
          name: "\u0411\u0435\u0437 \u0440\u0443\u0431\u0440\u0438\u043a\u0438",
          description: "",
        },
      ];

      return categoria;
    },

    getPosts() {
      /* return fetch(`${API_URL}/posts?per_page=20`).then((response) =>
        response.json()
      ); */

      let media = [
        
        //--------------------------------EXPERIENCIA LABORAL--------------------------------
        {
          title: "Cash Bakery",
          slug: "cash-bakery",
          categories: [5],
          meta: { year: "02.2026 - Present" },
          content: "<p>Senior Full Stack Developer<br>Multi-tenant cash-flow forecasting SaaS<br>Texas, USA (remote)</p>\n",
        },
        {
          title: "Ingeniería Digital",
          slug: "ingenieria-digital",
          categories: [5],
          meta: { year: "08.2024 - 03.2026" },
          content: "<p>Tech Lead · Senior Full Stack Developer · Software Architect<br>Asegurame insurtech platform: Guatemala, Costa Rica and Honduras</p>\n",
        },
        {
          title: "Grupo Financiero Ficohsa",
          slug: "ficohsa",
          categories: [5],
          meta: { year: "05.2023 - 08.2024" },
          content: "<p>Senior Software Architect (Architecture Officer)<br>Contracted via CONSISA</p>\n",
        },
        {
          title: "NextGO LLT",
          slug: "nextgo",
          categories: [5],
          meta: { year: "02.2022 - 02.2023" },
          content: "<p>Mid Full Stack Developer<br>Serby, local-services marketplace<br>Miami Beach, USA (remote)</p>\n",
        },
        {
          title: "Impact Mobile",
          slug: "impact-mobile",
          categories: [5],
          meta: { year: "01.2021 - 05.2022" },
          content: "<p>Full Stack Developer<br>E-commerce, bulk SMS and video streaming solutions</p>\n",
        },
        {
          title: "HUB UNITEC",
          slug: "hub-unitec",
          categories: [5],
          meta: { year: "08.2019 - 12.2020" },
          content: "<p>Web Master - WordPress<br>Innovation hub site: hub.unitec.edu</p>\n",
        },
        {
          title: "Iglesia de la Ciudad",
          slug: "iglesia-de-la-ciudad",
          categories: [5],
          meta: { year: "06.2016 - Present" },
          content: "<p>Volunteer - Audiovisual Media Technician<br>Live streaming, projection, photo and video editing</p>\n",
        },


        //--------------------------------PORTAFOLIO--------------------------------
        {
          title: "Cash Bakery",
          slug: "cash-bakery",
          categories: [8],
          meta: { site_url: "https://www.cashbakery.com/" },
          media_url: img("cash-bakery.webp"),
          tags: ["webapp", "landing"],
        },
        {
          title: "Asegurame Guatemala",
          slug: "asegurame-gt",
          categories: [8],
          meta: { site_url: "https://www.asegurame.gt/" },
          media_url: img("asegurame-gt.webp"),
          tags: ["webapp"],
        },
        {
          title: "CADERH - Statistical System (dashboard)",
          slug: "caderh-dashboard",
          categories: [8],
          meta: { site_url: "https://sgc.redcaderh.org/" },
          media_url: img("caderh.webp"),
          tags: ["webapp", "blog"],
        },
        {
          title: "CADERH - Statistical System (login)",
          slug: "sgc-caderh",
          categories: [8],
          meta: { site_url: "https://sgc.redcaderh.org/" },
          media_url: img("sgc-caderh.webp"),
          tags: ["webapp", "blog"],
        },
        {
          title: "ACG Honduras",
          slug: "acg-honduras",
          categories: [8],
          meta: { site_url: "https://www.acg.hn/" },
          media_url: img("acg-honduras.webp"),
          tags: ["landing"],
        },
        {
          title: "Impact Group",
          slug: "impact-group",
          categories: [8],
          meta: { site_url: "https://impact-group-landing.vercel.app/" },
          media_url: img("impact-group.webp"),
          tags: ["landing"],
        },
        {
          title: "FUTV",
          slug: "Impact",
          categories: [8],
          meta: { site_url: "" },
          media_url: img("itutor.webp"),
          tags: ["pwa"],
        },
        {
          title: "FUTV",
          slug: "Impact",
          categories: [8],
          meta: { site_url: "https://www.futvcr.com/" },
          media_url: img("futv.webp"),
          tags: ["landing"],
        },
        {
          title: "Impact Mobile Hn",
          slug: "Impact",
          categories: [8],
          meta: { site_url: "https://impactmobilehn.com/" },
          media_url: img("impact-mobile-hn.webp"),
          tags: ["landing"],
        },
        {
          title: "Sistema de Licitaciones",
          slug: "licitaciones",
          categories: [8],
          meta: { site_url: "" },
          media_url: img("sistema-licitaciones.webp"),
          tags: ["landing"],
        },
        {
          title: "FEREMA",
          slug: "ferema",
          categories: [8],
          meta: { site_url: "https://ferema.org/" },
          media_url: img("ferema.webp"),
          tags: ["landing"],
        },
        {
          title: "La Vinoteca",
          slug: "vinoteca",
          categories: [8],
          meta: { site_url: "" },
          media_url: img("la-vinoteca.webp"),
          tags: ["ecommerce"],
        },
        {
          title: "Description project 7",
          slug: "description-project-7",
          categories: [8],
          meta: { site_url: "https://hub.unitec.edu" },
          media_url: img("hub-unitec-inicio.webp"),
          tags: ["wordpress"],
        },
        {
          title: "INPREMA",
          slug: "wordpress",
          categories: [8],
          meta: { site_url: "https://inprema.gob.hn/" },
          media_url: img("inprema.webp"),
          tags: ["wordpress"],
        },
        {
          title: "Leer Para Empoderar",
          slug: "read-to-empower",
          categories: [8],
          meta: { site_url: "" },
          media_url: img("leer-para-empoderar.webp"),
          tags: ["landing"],
        },
        {
          title: "Desctioption project5",
          slug: "desctioption-project5",
          categories: [8],
          meta: {
            site_url:
              "https://jeymoda.minidux.com/",
          },
          media_url: img("jey-moda.webp"),
          tags: ["ecommerce"],
        },
        {
          title: "Desctioption project8",
          slug: "desctioption-project8",
          categories: [8],
          meta: { site_url: "https://rachel-beauty-center.minidux.com/" },
          media_url: img("rachel-beauty-center.webp"),
          tags: ["ecommerce"],
        },
        {
          title: "Desctioption project3",
          slug: "desctioption-project3",
          categories: [8],
          meta: { site_url: "https://donsanti.minidux.com/" },
          media_url: img("don-santi.webp"),
          tags: ["ecommerce"],
        },
        {
          title: "Description project2",
          slug: "description-project2",
          categories: [8],
          meta: { site_url: "https://santaburgadb.firebaseapp.com/#/login" },
          media_url: img("santa-burga.webp"),
          tags: ["blog"],
        },
        {
          title: "Desctioption project4",
          slug: "description4",
          categories: [8],
          meta: {
            site_url: "https://mailchi.mp/71ed39b196cb/naranja-republik-request-for-proposals",
          },
          media_url: img("naranja-republik.webp"),
          tags: ["newsletter"],
        },
        {
          title: "Description projects1",
          slug: "description-projects21",
          categories: [8],
          meta: { site_url: "https://mailchi.mp/778565c785ee/social-skin" },
          media_url: img("social-skin.webp"),
          tags: ["newsletter"],
        },
        {
          title: "Description projects1",
          slug: "description-projects20",
          categories: [8],
          meta: { site_url: "https://mailchi.mp/3accb2c357b0/startup-weekend-online-covid-19-hnd" },
          media_url: img("startup-weekend-covid19.webp"),
          tags: ["newsletter"],
        },
        {
          title: "Description projects1",
          slug: "description-projects19",
          categories: [8],
          meta: { site_url: "https://github.com/RALC365" },
          media_url: img("github-ralc365.webp"),
          tags: ["game"],
        },
        {
          title: "Description projects1",
          slug: "description-projects18",
          categories: [8],
          meta: { site_url: "https://mailchi.mp/4f92794afed9/innovation-world-cup" },
          media_url: img("innovation-world-cup.webp"),
          tags: ["newsletter"],
        },
        {
          title: "Description projects1",
          slug: "description-projects17",
          categories: [8],
          meta: { site_url: "https://github.com/RALC365/Snake-Vue" },
          media_url: img("snake-vue.webp"),
          tags: ["game"],
        },
        {
          title: "Description projects1",
          slug: "description-projects16",
          categories: [8],
          meta: { site_url: "https://dexchemical.minidux.com/" },
          media_url: img("dex-chemical.webp"),
          tags: ["ecommerce"],
        },
        {
          title: "Description project 6",
          slug: "description-project-6",
          categories: [8],
          meta: { site_url: "http://antiriskn.com/congreso/taller-de-matrices-de-riesgos/" },
          media_url: img("sala-virtual-arn.webp"),
          tags: ["wordpress"],
        },
        {
          title: "Description projects1",
          slug: "description-projects15",
          categories: [8],
          meta: { site_url: "https://unitec.edu" },
          media_url: img("diseno-tecnologico.webp"),
          tags: ["psd"],
        },
        {
          title: "Description projects1",
          slug: "description-projects14",
          categories: [8],
          meta: { site_url: "https://www.instagram.com/p/B4Big4aH2vr9PxZsKeH62yOXAUGvw3KYiX-bPw0/" },
          media_url: img("camisa-yo-emprendo-2019.webp"),
          tags: ["psd"],
        }, 
        
        {
          title: "Description projects1",
          slug: "description-projects13",
          categories: [8],
          meta: { site_url: "https://unitec.edu" },
          media_url: img("camisa-lego.webp"),
          tags: ["psd"],
        },
        {
          title: "Description projects1",
          slug: "description-projects12",
          categories: [8],
          meta: { site_url: "https://www.yumpu.com/es/document/read/63061285/reporte-anual-hub-2019" },
          media_url: img("reporte-anual-hub-2019.webp"),
          tags: ["psd"],
        },
        {
          title: "Description projects1",
          slug: "description-projects6",
          categories: [8],
          meta: { site_url: "https://blog.unitec.edu/2019/03/20/unitec-lanza-la-8va-edicion-del-premio-yo-emprendo/" },
          media_url: img("backdrop-yo-emprendo.webp"),
          tags: ["psd"],
        },
        {
          title: "Description projects1",
          slug: "description-projects5",
          categories: [8],
          meta: { site_url: "https://hub.unitec.edu" },
          media_url: img("hub-unitec-pwa.webp"),
          tags: ["pwa"],
        },
        {
          title: "Description projects1",
          slug: "description-projects4",
          categories: [8],
          meta: { site_url: "https://gluck-app-504.web.app/login" },
          media_url: img("gluck.webp"),
          tags: ["pwa"],
        },
        {
          title: "Description projects1",
          slug: "description-projects3",
          categories: [8],
          meta: { site_url: "https://drive.google.com/file/d/1Kvs7_Me8aGmyhJkM4qFu-1vxKDAYtLAk/view?usp=sharing" },
          media_url: img("iglesia-de-la-ciudad.webp"),
          tags: ["video"],
        },
        {
          title: "Description projects1",
          slug: "description-projects",
          categories: [8],
          meta: { site_url: "https://www.instagram.com/p/B_84f0knz3o/" },
          media_url: img("video-unitec.webp"),
          tags: ["video"],
        },
        {
          title: "Description projects1",
          slug: "description-projects22",
          categories: [8],
          meta: { site_url: "https://www.facebook.com/jovenesic1/videos/1851393651577471/?v=1851393651577471" },
          media_url: img("jovenes-ic.webp"),
          tags: ["video"],
        },
        

        
        
        
        
        

        


        {//--------------------------------EDUCACIÓN--------------------------------
          title: "Professional Software Architecture Course",
          slug: "courses",
          categories: [6],
          meta: { year: "10.2025" },
          content:
            "<p>Platzi</p>\n",
        },
        {
          title: "NASA Space Apps Challenge 2024",
          slug: "academy",
          categories: [6],
          meta: { year: "10.2024" },
          content:
            "<p>3rd place Honduras - Honduras Digital Challenge<br>Team Planetary CodeBreakers: 3D orrery to visualize near-Earth objects</p>\n",
        },
        {
          title: "Central American Technological University (UNITEC)",
          slug: "academy",
          categories: [6],
          meta: { year: "2017 - 2021" },
          content:
            "<p>B.Eng. in Computer Systems Engineering<br>Full scholarship</p>\n",
        },
        {
          title: "Erasmus+ IRUDESCA Award - International Internship",
          slug: "academy",
          categories: [6],
          meta: { year: "06.2018 - 07.2018" },
          content:
            "<p>Grupo 361, Guatemala - Universidad Rafael Landívar / European Union</p>\n",
        },
        {
          title: "Modules and Competition IRUDESCA - Erasmus+",
          slug: "academy",
          categories: [6],
          meta: { year: "08.2017 - 05.2018" },
          content:
            "<p>Innovative Management Skills<br>Business Innovation and Value Chain Development</p>\n",
        },
        {
          title: "Recognition - Startup Weekend",
          slug: "academy",
          categories: [6],
          meta: { year: "08.2017" },
          content:
            "<p>\"I'm Volunteer\" Initiative</p>\n",
        },
        {
          title: "Match Competition",
          slug: "academy",
          categories: [6],
          meta: { year: "2016" },
          content:
            "<p>Individual and team: 1st place, +Taular<br>2nd place in CVC</p>\n",
        },
        {
          title: "Smart Factory of Tigo and Drone Challenge,<br>IHCIETI and Tigo Foundation",
          slug: "courses",
          categories: [6],
          meta: { year: "05.2016 - 07.2016" },
          content: "<p>Fundamentals of app development</p>\n",
        },
        {
          title: "Taular Technological Institute",
          slug: "academy",
          categories: [6],
          meta: { year: "2012 - 2016" },
          content:
            "<p>High School Diploma in Science and Humanities: Academic Excellence<br>Certification course in web development with JavaScript, HTML, CSS and MySQL</p>\n",
        },




        {//--------------------------------INFORMACIÓN PERSONAL--------------------------------
          title: "PERSONAL INFORMATION",
          slug: "personal-information",
          categories: [2],
          meta: {
            font_awesome: [
              "icon-linkedin-squared, https://www.linkedin.com/in/richardson-carcamo",
              "icon-github-squared, https://github.com/RALC365",
            ],
            phone: "+5\u043e4 9493-8\u043e43",
            country: "Honduras",
            city: "Tegucigalpa, Francisco Morazán, Honduras",
            email: "richardsoncarcamo@gmail.com",
            skype: "RALC365",
            phone_icon: "icon-mobile",
            adress_icon: "icon-direction",
          },
        },
        {
          title: "Few words about me",
          slug: "few-words-about-me",
          categories: [2],
          meta: [],
          media_url:
            "http://portfolio.freaksidea.com/wp-content/uploads/2017/03/photo-1.jpeg",
          content:
            '<p><span style="font-weight: 400;">I\u2019m a Senior Full Stack Developer with more than <span id="yearExperience"></span> years in web development, building applications end to end across frontend, backend, cloud infrastructure and DevOps, with team leadership and software architecture on international projects.</span></p>\n'
            + '<p>I\u2019m currently building a multi-tenant cash-flow forecasting SaaS for U.S. fitness and wellness studios. Before that I was tech lead of Asegurame, an insurtech platform with 12 insurance carrier integrations across 3 countries, and software architecture officer at one of Central America\u2019s largest financial groups.</p>\n'
            + '<p>As a person, I dedicate myself to learning from everything I can be taught, and to supporting others whenever I have the opportunity, as long as it does not represent harm to themselves or others.</p>'
            + '<span style="font-weight: 400;">"Be kind, be useful, be fearless" - Barack Obama</span>',
        },
      ];
      return media
    },

    groupPosts(posts, categories) {
      const categoriesById = group(categories, "id");

      return posts.reduce((acc, post) => {
        post.categories.forEach((categoryId) => {
          const key = categoriesById[categoryId].slug;
          acc[key] = acc[key] || [];
          acc[key].push(post);
        });

        return acc;
      }, {});
    },
  },

  created() {
    document.body.classList.add('loading')
    Promise.all([
      this.getCategories(),
      this.getPosts(),
      this.getName(),
    ]).then(([categories, posts]) => {
      this.categories = group(categories)
      this.posts = this.groupPosts(posts, categories)
      this.isLoaded = true
      this.$nextTick(() => document.body.classList.remove('loading'))
    })
  },
}
</script>

<style scoped lang="scss">
$spinner-loader-color: rgba(#003, 0.3) !default;

.wrapper {
  height: 100%;
}

.loader {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
}


@keyframes spinner-loader {
  0%   {
    transform: rotateZ(0deg);
  }

  100% {
    transform: rotateZ(360deg);
  }
}

.spinner-loader {
  animation: spinner-loader 1500ms infinite linear;

  border-radius: 0.5em;
  box-shadow: $spinner-loader-color 1.5em 0 0 0,
    $spinner-loader-color 1.1em 1.1em 0 0,
    $spinner-loader-color 0 1.5em 0 0,
    $spinner-loader-color -1.1em 1.1em 0 0,
    $spinner-loader-color -1.5em 0 0 0,
    $spinner-loader-color -1.1em -1.1em 0 0,
    $spinner-loader-color 0 -1.5em 0 0,
    $spinner-loader-color 1.1em -1.1em 0 0;
  display: inline-block;
  font-size: 10px;
  width: 1em;
  height: 1em;
  margin: 1.5em;
  overflow: hidden;
  text-indent: 100%;
}
</style>
